module.exports = {
  apiUrl: 'https://api.lichenstg.com',
  bucket: 'home.lichenstg.com',
  logout: 'lichenstg.com/logout',
  sentry: {
    dsn: 'https://e89017876a1d4798a67eb0d971289c49@sentry.io/1861374',
    env: 'STAGING'
  }
}
